import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { ConfigService } from '../config.service';
import { UserService } from '../user.service';
import { File360Resources } from '../resources';
import { File360Component } from '../component.model';

@Component({
  selector: 'file360-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  year: string;
  productVersion: string;
  selectedTab: SelectedAboutTab = SelectedAboutTab.About;
  systemInfo: string = "";

  constructor(private configService: ConfigService, private userService: UserService) {
    this.year = environment.year;
    this.productVersion = environment.productVersion;
  }

  ngOnInit() {
    this.userService.componentInit$.next(new File360Component(File360Resources.componentTitleAbout));

    this.configService.loadSystemInfo().subscribe(systemInfo => {
      this.systemInfo = (systemInfo as string).replace(/\n/g, "<br/>");
    });
  }

  selectTab(selectTabIndex: number) {
    this.selectedTab = selectTabIndex;
  }
}

const enum SelectedAboutTab {
  About = 0,
  System = 1,
  Contact = 2
};
